import { render, staticRenderFns } from "./newPurchaseRma.vue?vue&type=template&id=7309940e&"
import script from "./newPurchaseRma.vue?vue&type=script&lang=js&"
export * from "./newPurchaseRma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports